import React, { Component } from "react";
import { dispatch } from "@rematch/core";
import { Form, Input, Segment, Header, Divider, Button, Message } from "semantic-ui-react";
import LoadingComponent from "../../../../common/LoadingComponent";
// import axios from "axios";

export default class ConsumptionBilling extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fields: {
        playbooksGenerated: "",
        playbookCreated: "",
        playbookPublished: "",
        playbookExported: "",
        activityCreated: "",
        activitiesGenerated: "",
        initiativeCreated: "",
        linksGenerated: "",
        teamsCreated: "",
        invitesCreated: "",
        scenarioExecution: "",
        costPerOperation: "",
      },
      errors: {},
      loading: false,
      success: false,
    };
  }

  componentDidMount() {
    // Load current defaults if available
    this.loadCurrentConfig();
  }

  async loadCurrentConfig() {
    try {
      await dispatch.account.getBillingDefaulfs() // Replace with your FeathersJS API endpoint
      if(this.props.billingDefaults && Object.keys(this.props.billingDefaults).length > 0){
        this.setState({ fields: this.props.billingDefaults.defaults || {} });
      }
    } catch (err) {
      console.error("Error loading defaults:", err);
    }
  }

  handleChange = (e, { name, value }) => {
    const numericValue = value === "" ? "" : Number(value);
    this.setState({
      fields: { ...this.state.fields, [name]: numericValue },
    });
  };

  validateFields = () => {
    const { fields } = this.state;
    const errors = {};

    Object.keys(fields).forEach((key) => {
      if (key === "costPerOperation") return;
      if (fields[key] === "" || isNaN(fields[key])) {
        errors[key] = "required.";
      } else if (fields[key] < 0) {
        errors[key] = "Must be ≥ 0.";
      }
    });
    if (
      fields.costPerOperation === "" ||
      isNaN(fields.costPerOperation) ||
      fields.costPerOperation < 0
    ) {
      errors.costPerOperation = "Enter a valid cost.";
    }
    this.setState({ errors });
    return Object.keys(errors).length === 0;
  };

  handleSubmit = async () => {
    if (!this.validateFields()) return;

    this.setState({ loading: true, success: false });

    try {
      await dispatch.account.addOrUpdateBillingDefaults({defaults:this.state.fields, type:'default'});
    //   await axios.patch("/consumption-defaults", this.state.fields); // PATCH or POST based on your service
      this.setState({ loading: false, success: true });
    } catch (err) {
      console.error("Error saving configuration:", err);
      this.setState({ loading: false });
    }
  };

  renderField = (label, name) => {
    const { fields, errors } = this.state;
    return (
      <Form.Field error={!!errors[name]}>
        <label>{label}<span style={{color:"red"}}>*</span></label>
        <Input
          type="number"
          name={name}
          min="0"
          value={fields[name]}
          placeholder="Enter value"
          onChange={this.handleChange}
        />
        {errors[name] && <span style={{ color: "red" }}>Number of operations {errors[name]}</span>}
      </Form.Field>
    );
  };

  render() {
    const { loading, success , fields, errors} = this.state;

    return (
      <Segment padded="very">
        <LoadingComponent
          active={loading}
          message="Loading Consumption Billing Configuration..."
        />
        <Header as="h2" dividing>
          Configure Default Consumption Operations
        </Header>
        <Form loading={loading}>
          <Header as="h3">Playbooks</Header>
          {this.renderField("Playbooks Generated with AI", "playbooksGenerated")}
          {this.renderField("Playbooks Manually Created", "playbookCreated")}
          {this.renderField("Playbooks Published", "playbookPublished")}
          {this.renderField("Documents Generated", "playbookExported")}
          <Divider />

          <Header as="h3">Activities</Header>
          {this.renderField("Activities Generated with AI", "activitiesGenerated")}
          {this.renderField("Activities Manually Created", "activityCreated")}
          {this.renderField("Content Researched (AI - Link)", "linksGenerated")}
          <Divider />

          <Header as="h3">Initiatives</Header>
          {this.renderField("Projects & Initiatives Active", "initiativeCreated")}

          <Divider />

          <Header as="h3">Teams & Users</Header>
          {this.renderField("Teams Created", "teamsCreated")}
          {this.renderField("Users Added", "invitesCreated")}
          <Divider />

          <Header as="h3">Workflows</Header>
          {this.renderField("Workflows Activated (Make)", "scenarioExecution")}
          <Divider />
          
          <Header as="h3">Cost Configuration</Header>
          <Form.Field error={!!errors.costPerOperation}>
            <label>Cost per Operation ($)<span style={{color:"red"}}>*</span></label>
            <Input
              type="number"
              name="costPerOperation"
              step="0.01"
              min="0"
              value={fields.costPerOperation}
              placeholder="e.g. 0.05"
              onChange={this.handleChange}
            />
            {errors.costPerOperation && (
              <span style={{ color: "red" }}>{errors.costPerOperation}</span>
            )}
          </Form.Field>
          <Divider />
          <Button
            primary
            onClick={this.handleSubmit}
            loading={loading}
            content="Save Configuration"
          />

          {success && (
            <Message
              positive
              header="Success"
              content="Configuration saved successfully!"
            />
          )}
        </Form>
      </Segment>
    );
  }
}
